<template>
  <b-nav-item-dropdown right no-caret v-if="user">
    <b-btn slot="button-content" variant="warning" size="sm" class="text-white">
      アカウント管理
    </b-btn>
    <b-dropdown-header tag="div" class="text-center"><small v-if="user.office_name && user.office_name.length > 0">{{ user.office_name }}<br><img :src="getAvatarSrc(user)" class="img-avatar" :alt="user.name"></small><strong>{{ user.name }} 様</strong></b-dropdown-header>
    <b-dropdown-item @click.prevent="$router.push({ name: 'settings.profile' })"><i class="fa fa-user"></i> プロフィール管理</b-dropdown-item>
    <b-dropdown-item @click.prevent="$router.push({ name: 'settings.personal' })"><i class="fa fa-address-card"></i> 個人情報管理</b-dropdown-item>
    <b-dropdown-item @click.prevent="$router.push({ name: 'settings.notifications' })"><i class="fa fa-bell"></i> 通知管理</b-dropdown-item>
    <b-dropdown-item @click.prevent="$router.push({ name: 'settings.email' })"><i class="fa fa-at"></i> メールアドレス変更</b-dropdown-item>
    <b-dropdown-item @click.prevent="$router.push({ name: 'settings.password' })"><i class="fa fa-lock"></i> パスワード変更</b-dropdown-item>
    <b-dropdown-item @click.prevent="logout"><i class="fa fa-sign-out"></i> ログアウト</b-dropdown-item>
  </b-nav-item-dropdown>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data: () => ({
    appName: window.config.appName
  }),

  computed: mapGetters({
    user: 'auth/user'
  }),

  methods: {
    async logout () {
      // Log out the user.
      await this.$store.dispatch('auth/logout')

      // Redirect to login.
      this.$router.push({ name: 'login' })
    },

    getAvatarSrc(user) {
      if ( user != null && user.media_data != null && user.media_data.avatar != null && user.media_data.avatar.length > 0 ) {
        let image = user.media_data.avatar[0]
        return '/storage/uploads/' + image.directory + image.filename + '.' + image.extension
      }
      return '/images/no_image.svg'
    }
  }
}
</script>

<style lang="scss" scoped>
.img-avatar {
  height: 25px;
  width: 25px;
  margin-right: 0.5rem
}
</style>


// WEBPACK FOOTER //
// resources/js/components/Header/HeaderDropdown.vue